import { render, staticRenderFns } from "./BannerWithLogo.vue?vue&type=template&id=efc4c4b0&scoped=true&"
import script from "./BannerWithLogo.vue?vue&type=script&lang=js&"
export * from "./BannerWithLogo.vue?vue&type=script&lang=js&"
import style0 from "./BannerWithLogo.vue?vue&type=style&index=0&id=efc4c4b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc4c4b0",
  null
  
)

export default component.exports